export { FontProvider } from './FontProvider';
export type { FontDisplay } from './FontProvider';
export type { FontFaceSpec, FontFamilyToken, FontLoad } from './types';

// PP Mori: family token + each variant as a separately importable face.
// Importing only the variants you need keeps the bundle small.
export { ppMori } from './pp-mori';
export {
  ppMoriExtraLight,
  ppMoriExtraLightItalic,
  ppMoriLight,
  ppMoriLightItalic,
  ppMoriBook,
  ppMoriBookItalic,
  ppMoriRegular,
  ppMoriRegularItalic,
  ppMoriMedium,
  ppMoriMediumItalic,
  ppMoriSemiBold,
  ppMoriSemiBoldItalic,
  ppMoriBold,
  ppMoriBoldItalic,
  ppMoriExtraBold,
  ppMoriExtraBoldItalic,
} from './pp-mori/variants';
